import { RootState } from 'theSource/app/store';
import { BenefitCategory } from 'theSource/queries';

export const benefitCategorySelector = (state: RootState) => {
  return (
    state?.enrollment?.benefitCategories?.benefitCategoryData as {
      benefitsCategory: BenefitCategory[];
    }
  )?.benefitsCategory;
};
